import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { checkParams } from "../../../src/util/Util";
import axios from "axios";
import Header from "../../components/header/Header";
import "./VerifyAdminPassword.css";

const VerifyAdminPassword = (props) => {
  let { firstName } = useParams();
  let { lastName } = useParams();
  let { email } = useParams();
  let { companyId } = useParams();
  let { businessId } = useParams();
  let { code } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    props.actSidebar(false);
    props.checkLoggedIn(false);
  }, [props]);

  const [passAllValid, setPassAllValid] = useState(false);
  const [charLengthValid, setCharLengthValid] = useState(false);
  const [hasLetter, setHasLetter] = useState(false);
  const [hasNum, setHasNum] = useState(false);
  const [hasSpecChar, setHasSpecChar] = useState(false);
  // eslint-disable-next-line
  const [successLoad, setSuccessLoad] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [passVisible1, setPassVisible1] = useState(false);
  const [passVisible2, setPassVisible2] = useState(false);
  const [errorPassword, setErrorPassword] = useState("");
  // const [returnedEmail, setReturnedEmail] = useState("");
  const [isLoaded, setIsLoaded] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const sweepThroughTickers = (value) => {
    setErrorPassword("");
    setCharLengthValid(checkParams(value, "charLength"));
    setHasLetter(checkParams(value, "hasLetter"));
    setHasNum(checkParams(value, "hasNum"));
    setHasSpecChar(checkParams(value, "hasSpecChar"));
    setPassword1(value);
    if (
      checkParams(value, "charLength") &&
      checkParams(value, "hasLetter") &&
      checkParams(value, "hasNum") &&
      checkParams(value, "hasSpecChar")
    ) {
      setPassAllValid(true);
    } else {
      setPassAllValid(false);
    }
  };

  useEffect(() => {
    setIsLoaded(false);
    axios
      .post(window.ajaxLink + "cloud_therapist/verify-invitation-code", {
        invitationCode: code,
        adminEmail: email
      })
      .then((res) => {
        if (res.data.responseData) {
          setIsLoaded(true);
        }
      })
      .catch((error) => {
        console.error(error.response.data.errorData);
        setIsLoaded(true);
        if (error.response.data.responseCode === 417) {
          setShowModal(true);
          setModalMessage(error.response.data.errorData);
        }
      });
      // eslint-disable-next-line
  }, [code]);

  const handleReset = (value) => {
    setErrorPassword("");
    if (checkParams(value, "password")) {
      setErrorPassword("Invalid password!");
      return false;
    }
    if (checkParams(value, "password")) {
      setErrorPassword("Invalid password!");
      return false;
    }
    if (password1 !== password2) {
      setErrorPassword("Passwords are not the same.");
      return false;
    }

    axios
      .post(window.ajaxLink + "cloud_therapist/register-company-admin", {
        adminFirstName: firstName,
        adminLastName: lastName,
        adminEmail: email,
        adminCompanyId: companyId,
        adminBusinessId: businessId,
        adminPassword: password2,
        invitationCode: code,
      })
      .then((res) => {
        if (res.data.responseData) {
          dashboardProceed(res.data.responseData);
        }
      })
      .catch((error) => {
        console.error(error.response.data.errorData);
        if (error.response.data.responseCode === 417) {
          setErrorPassword(error.response.data.errorData);
        }
      });
  };

  const dashboardProceed = (email) => {
    setSuccessLoad("");
    axios
      .post(window.ajaxLink + "user/login", {
        email: email.trim(),
        password: password2,
        cloud: true,
      })
      .then((res) => {
        if (res.data.responseCode === 200) {
          localStorage.setItem("userData", JSON.stringify(res.data.responseData));
          props.checkLoggedIn(true);
          navigate("/dashboard");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
// eslint-disable-next-line
  const handleCancel = () => {
    setSuccessLoad("");
    navigate("/");
  };

  const handleModal = () => {
    setShowModal(false);
    navigate("/login");
  };

  return (
    <>
      <div>
        <Header />
        <div className="memberRegisterContainer forgot_contain">
          <div className="memberRegisterHolder verify-admin-container">
            <h1 className="admin-verify-title">Welcome to Virdio Health</h1>
            <p>Complete your registration as a Clinician on Virdio Health by creating a password</p>
            <div className="info_row_holder">
              <div className="form_title">Enter your password</div>
              <div className="relative_holder">
                <input
                  type={passVisible1 ? "text" : "password"}
                  className="gray_inputs gray_inputs_login"
                  onChange={(e) => sweepThroughTickers(e.currentTarget.value)}
                />
                <div className="eye_show" onClick={() => setPassVisible1(!passVisible1)}>
                  {passVisible1 && <div className="crossed_eye"></div>}
                </div>
              </div>
              {password1.length > 0 && (!charLengthValid || !hasLetter || !hasNum || !hasSpecChar) && (
                <>
                  <div className="reg_pass_check_contain">
                    <div className={"reg_pass_ticker" + (charLengthValid ? " rpass_true" : "")}></div>
                    Must be at least 8 characters
                  </div>
                  <div className="reg_pass_check_contain">
                    <div className={"reg_pass_ticker" + (hasLetter ? " rpass_true" : "")}></div>
                    Minimum 1 Letter
                  </div>
                  <div className="reg_pass_check_contain">
                    <div className={"reg_pass_ticker" + (hasNum ? " rpass_true" : "")}></div>
                    Minimum 1 Number
                  </div>
                  <div className="reg_pass_check_contain">
                    <div className={"reg_pass_ticker" + (hasSpecChar ? " rpass_true" : "")}></div>
                    Minimum 1 Special character
                  </div>
                </>
              )}
              <div className="form_title">Confirm Password</div>
              <div className="relative_holder">
                <input
                  type={passVisible2 ? "text" : "password"}
                  className="gray_inputs gray_inputs_login"
                  onChange={(e) => setPassword2(e.currentTarget.value)}
                />
                <div className="eye_show" onClick={() => setPassVisible2(!passVisible2)}>
                  {passVisible2 && <div className="crossed_eye"></div>}
                </div>
              </div>
              <>{errorPassword && <div className="email_error_msg">{errorPassword}</div>}</>
            </div>
            <div className="bottomLoginPadding">
              {passAllValid && password1 === password2 ? (
                <div className="signNewButton signNew_login" onClick={() => handleReset()}>
                  Get Started
                </div>
              ) : (
                <div className="signNewButton signNew_login proceed_disabled">Get Started</div>
              )}
            </div>
          </div>
        </div>
      </div>
      {!isLoaded && (
        <div className="full_page_loader_container">
          <div className="p_load full_page_loader_centerd"></div>
        </div>
      )}
      {showModal && (
        <div className="dlt_wrapper company-admin-modal">
          <div className="dbl_place_on_page">
            <div className="dlt_surround ">
              <div className="dlt_description">{modalMessage}</div>
              <div className="dlt_exit_btm">
                <div className="dlt_exit_btn dlt_eb_scnd dlt_lone_btn" onClick={handleModal}>
                  Go to Login
                </div>
              </div>
            </div>
          </div>
          <div className="approval_close tsk_info_cls" onClick={handleModal}></div>
        </div>
      )}
    </>
  );
};

export default VerifyAdminPassword;
